import React from 'react';
import MensajeCargando from './MensajeCargando.js';
import MensajeError from './MensajeError.js';
import MensajeGrabando from './MensajeGrabando.js';
import styles from './CuadroDatos.module.css';

const CuadroDatos = (props) => {
  const titulo = props.titulo;
  const mostrar = props.mostrar || true;
  const isCargando = props.isCargando;
  const isGrabando = props.isGrabando;
  const error = props.error;
  const minHeight = props.minHeight;

  return (
    <React.Fragment>
      {titulo && mostrar && (
        <div className={`${styles.cuadroDatos}`} style={minHeight ? { minHeight } : undefined}>
          <span className={`${styles.tituloCuadroDatos}`}>{titulo}</span>
          {props.children}
          <MensajeCargando isCargando={isCargando} />
          <MensajeGrabando isGrabando={isGrabando} />
          <MensajeError errores={error} />
        </div>
      )}
    </React.Fragment>
  );
};

export default CuadroDatos;
